export const styleConstants = {
    HEADER_HEIGHT: 60,
    HEADER_X_PADDING: 0,
    PADDING_X_HOME: 20,
    PADDING_Y_HOME: 10,
    PRIMARY_COLOR: "#FFFFFF",
    SECONDARY_COLOR: "#000000",
    BACKGROUND_COLOR_LAYOUT: "#000",
    FILTER_SIDEBAR_OPEN: '80px',
    FILTER_SIDEBAR_DEFAULT: '40px',
}

export const getAccountId = () => {
  let accountId;
  switch (window.location.hostname) { 
    case 'tickets.soyoscaralarcon.com':
      accountId = 'oscar-alarcon';
      break;
    case 'sobreruedasok.com':
      accountId = 'sobre-ruedas-ok';
      break;
    case 'rifasellargo.vercel.app':
      accountId = 'rifas-el-largo';
      break;
    case 'rifasellargo.com':
      accountId = 'rifas-el-largo';
      break;
    case 'rifas-jh-blessd.vercel.app':
      accountId = 'rifas-jh-blessd';
      break;
    case 'ganaconanthonyflow.vercel.app':
      accountId = 'anthony-flow';
      break;
    case 'digitalgrowdp.vercel.app':
      accountId = 'grow-dp';
      break;
    case 'gerej16.com':
      accountId = 'gerej-16';
      break;
    case 'jj-platinum.vercel.app':
      accountId = 'jj-platinum';
      break;
    case 'bendecidosconvilla.vercel.app':
      accountId = 'bendecidos-con-villa';
      break;
    case 'unavisionrifas.vercel.app':
      accountId = 'una-vision';
      break;
    case 'fauiaguirre.vercel.app':
      accountId = 'galenstar';
      break;
    case 'goyo2time.com':
      accountId = 'goyo2time';
      break;
    case 'agudojhonny.vercel.app':
      accountId = 'agudojhonny';
      break;
    case 'rifasport.vercel.app':
      accountId = 'rifa-sport';
      break;
    case 'lasminasdebaruta.com':
    case 'lasminasdebaruta.vercel.app':
      accountId = 'minas-de-baruta';
      break;
    case 'soyoscaralarcon.com':
      accountId = 'oscar-alarcon-promo';
      break;
    case 'rifasbuenaventura.com':
      accountId = 'buenaventura';
      break;
    case 'apuestaconaleyjef.vercel.app':
      accountId = 'ale-jef';
      break;
    case 'maikel-dominguez.com':
      accountId = 'maikel-dominguez';
      break;
    case 'blssd-discbar-zz.vercel.app':
      accountId = 'blessed-disc-bar-zz';
      break;
    case 'danielcontrerasrifas.com':
      accountId = 'danielcontrerasrifas';
      break;
    case 'rifas.jaimezmaikel.com':
      accountId = 'maikel-jaimez';
      break;
    case 'luis-bigrau.vercel.app':
      accountId = 'luis-bigrau';
      break;
    case 'rifaslmg.com':
      accountId = 'rifas-lmg';
      break;
    case 'juegaconmariangel.com':
      accountId = 'w-robles';
      break;
    case 'rifas-cachorro.vercel.app':
      accountId = 'rifas-cachorro';
      break;
    case 'gnrifas.vercel.app':
      accountId = 'gn-rifas';
      break;
    case 'rifas-oriente.vercel.app':
      accountId = 'rifas-oriente';
      break;
    case 'yoiber-mota.vercel.app':
      accountId = 'yoiber-mota';
      break;
    case 'lavueltaesdios.vercel.app':
      accountId = 'lavueltaesdios';
      break;
    case 'antoni-contreras.vercel.app':
      accountId = 'antoni-contreras';
      break;
    case 'antoni-contreras.vercel.app':
      accountId = 'antoni-contreras';
      break;
    case 'rifasmotorluck.com':
      accountId = 'motor-luck';
      break;
    case 'zpremio.com':
      accountId = 'zpremio';
      break;
    case 'juegaconjgr.vercel.app':
      accountId = 'jgr1';
      break;
    case 'lotofer.vercel.app':
      accountId = 'lotofer';
      break;
    case 'rifasjonaiker.vercel.app':
      accountId = 'rifas-jonaiker';
      break;
    case 'flowshopccs.vercel.app':
      accountId = 'flow-shop';
      break;
    case 'rifaslosninos.com':
      accountId = 'los-ninos';
      break;
    case 'rifaselbarines.vercel.app':
      accountId = 'el-barines';
      break;
    case 'rifas-naguara.vercel.app':
      accountId = 'rifas-naguara';
      break;
    case 'rifasnaguarajc.com':
      accountId = 'rifas-naguara';
      break;
    case 'white-lion.vercel.app':
      accountId = 'white-lion';
      break;
    case 'ruedasextremas.vercel.app':
      accountId = 'ruedas-extremas';
      break;
    case 'elrifazo.vercel.app':
      accountId = 'el-rifazo';
      break;
    case 'localhost':
      accountId = 'rifa-sport';
      break;
    case 'rifasroalis.vercel.app':
      accountId = 'rifas-roalis';
      break;
    case 'lobovzla1.vercel.app':
      accountId = 'lobo-guarenas';
      break;
    case 'rifasloschamos.vercel.app':
      accountId = 'rifas-los-chamos';
      break;
    case 'rifaschente.vercel.app':
      accountId = 'rifas-chente';
      break;
    case 'apuestasvip58.vercel.app':
      accountId = 'a-donde-la-negra';
      break;
    case '2025easycars.vercel.app':
      accountId = 'easy-cars';
      break;
    case 'ganamosconantoni.net':
      accountId = 'ganamos-con-antoni';
      break;
    case 'monino.vercel.app':
      accountId = 'monino';
      break;
    case 'yourrmann.vercel.app':
      accountId = 'yourrmann';
      break;
    case 'alexvargas.vercel.app':
      accountId = 'alex-vargas';
      break;
    case 'rifasdeluxe1.com':
      accountId = 'rifas-deluxe';
      break;
    case 'agudojhonny.vercel.app':
      accountId = 'agudojhonny';
      break;
    case 'eldeguarataroyilsongrau.vercel.app':
      accountId = 'yilson-grau';
      break;
    case 'franyerjar.vercel.app':
      accountId = 'franyer-jar';
      break;
    case 'alejandroelgochito.com':
      accountId = 'alejandro-el-gochito';
      break;
    case 'laguairamarket.vercel.app':
      accountId = 'la-guaira-market';
      break;
    case 'emmanueldograu.vercel.app':
      accountId = 'emmanuel-dograu';
      break;
    case 'jfrifas.vercel.app':
      accountId = 'rifas-jf';
      break;
    case 'rifasloshermanos.vercel.app':
      accountId = 'rifas-los-hermanos';
      break;
    case 'ganaconjohnbi.vercel.app':
      accountId = 'gana-con-johnbi';
      break;
    case 'rifaselmono.vercel.app':
      accountId = 'el-mono';
      break;
    case 'angeelhr26.vercel.app':
      accountId = 'angel-hernandez';
      break;
    case 'jfrifas.com':
      accountId = 'rifas-jf';
      break;
    case 'rifastj.vercel.app':
      accountId = 'rifas-tj';
      break;
    case 'rifa-bera-2025.vercel.app':
      accountId = 'rifa-bera-2025';
      break;
    case 'ganaconleonardo.vercel.app':
      accountId = 'gana-con-leonardo';
      break;
    case 'rifasjj.com':
      accountId = 'rifas-jj';
      break;
    case 'tickets.ganaconsalazar.com':
      accountId = 'gana-con-salazar';
      break;
    case 'conlosmendozasegana.vercel.app':
      accountId = 'b-mendoza';
      break;
    case 'fuulldiesel.vercel.app':
      accountId = 'full-diesel';
      break;
    case 'losnietos.vercel.app':
      accountId = 'los-primos';
      break;
    case 'rifasdepaquete.vercel.app':
      accountId = 'rifas-de-paquete';
      break;
    case 'suenaengrande.vercel.app':
      accountId = 'suena-en-grande';
      break;
    case 'hernancitojr.vercel.app':
      accountId = 'hernancito-jr';
      break;
    case 'rifaslosvelocistas.com':
      accountId = 'carlos-pinango';
      break;
    case 'rommy18.vercel.app':
      accountId = 'rommy-18';
      break;
    case 'rifalosprimos.vercel.app':
      accountId = 'rifa-los-primos';
      break;
    case 'wildliferescue.vercel.app':
      accountId = 'wild-life-rescue';
      break;
    case 'ganaconjuancho.vercel.app':
      accountId = 'gana-con-juancho';
      break;
    case 'puntoaltoikigai.vercel.app':
      accountId = 'punto-alto-ikigai';
      break;
    case 'elviejomotorepuestos.com':
      accountId = 'el-viejo';
      break;
    case 'ganaconlaurys.vercel.app':
      accountId = 'gana-con-laurys';
      break;
    case 'fsmrifas.vercel.app':
      accountId = 'fsm-rifas';
      break;
    case 'juegayganaconzapata.com':
      accountId = 'juega-con-zapata';
      break;
    case 'sandetusuerte.vercel.app':
      accountId = 'san-de-tu-suerte';
      break;
    case 'rifas-va.vercel.app':
      accountId = 'rifas-va';
      break;
    case 'larifadelexito.vercel.app':
      accountId = 'la-rifa-del-exito';
      break;
    case 'brotherifas.vercel.app':
      accountId = 'brotherifas';
      break;
    case 'notlicenciaprocess.vercel.app':
      accountId = 'not-licencia-process';
      break;
    case 'rifaslabotija.vercel.app':
      accountId = 'rifas-la-botija';
      break;
    case 'superifaslatam.vercel.app':
      accountId = 'super-rifas-latam';
      break;
    case 'jayakuza.vercel.app':
      accountId = 'jayakuza';
      break;
    case 'rifasgritacaracas.vercel.app':
      accountId = 'grita-caracas';
      break;
    case 'ganaconibelles.vercel.app':
      accountId = 'gana-con-ibelles';
      break;
    case 'rifaloca.vercel.app':
      accountId = 'rifa-loca';
      break;
    case 'greko-rifando.vercel.app':
      accountId = 'greko-rifando';
      break;
    case 'ganaconbonis.vercel.app':
      accountId = 'gana-con-bonis';
      break;
    case 'rifasyaracuy.vercel.app':
      accountId = 'rifas-yaracuy';
      break;
    case 'labaerberia2-1.vercel.app':
      accountId = 'la-barberia';
      break;
    case 'rifasflowexotico.vercel.app':
      accountId = 'flow-exotico';
      break;
    case 'johan04eventos.vercel.app':
      accountId = 'johan-eventos';
      break;
    case 'gordoloto.com':
      accountId = 'gordoloto';
      break;
    case 'djtito2025.vercel.app':
      accountId = 'dj-tito';
      break;
    case 'ultraganador.vercel.app':
      accountId = 'ultra-ganador';
      break;
    case 'monolokura.com':
      accountId = 'mono-lokura';
      break;
    case 'eldelpuertorifas.vercel.app':
      accountId = 'el-del-puerto-rifas';
      break;
    case 'rifaselnay.vercel.app':
      accountId = 'el-nay';
      break;
    case 'rifaselcharro.vercel.app':
      accountId = 'rifas-el-charro';
      break;
    case 'ganaconluxury.vercel.app':
      accountId = 'gana-con-luxury';
      break;
    case 'theshow2001.vercel.app':
      accountId = 'the-show-2001';
      break;
    case 'dilangrau.vercel.app':
      accountId = 'dilan-grau';
      break;
    case 'diegomerchan10.vercel.app':
      accountId = 'diego-merchan';
      break;
    case 'kevinmunozrifas.vercel.app':
      accountId = 'kevin-munoz';
      break;
    case 'rifaspc.vercel.app':
      accountId = 'rifas-pc';
      break;
    case 'tusrifasrt.vercel.app':
      accountId = 'tus-rifas-rt';
      break;
    case 'antonyrifas.vercel.app':
      accountId = 'tony-12-grau';
      break;
    case 'afortunados.vercel.app':
      accountId = 'afortunados';
      break;
    case 'rifaspetare.vercel.app':
      accountId = 'rifas-petare';
      break;
    case 'eldelah.vercel.app':
      accountId = 'el-de-la-h';
      break;
    default:
      accountId = 'rifa-sport';
      break;
  }
  
  return accountId;
}

export const getPrimaryColorByAccountId = (accountId: string): string => {
  switch (accountId) {
    case "oscar-alarcon":
    case "la-barberia":
    case "gana-con-luxury":
    case "rifas-de-paquete":
    case "rommy-18":
    case "jj-platinum":
    case "una-vision":
    case "rifa-bera-2025":
    case "rifas-jj":
    case "carlos-pinango":
    case "gana-con-johnbi":
    case "rifas-el-largo":
    case "diego-merchan":
    case "rifas-la-botija":
    case "tus-rifas-rt":
    case "rifas-los-hermanos":
    case "gana-con-leonardo":
    case "rifas-tj":
    case "kevin-munoz":
    case "el-de-la-h":
    case "brotherifas":
    case "hernancito-jr":
      return "#FFFF00"
    case "super-rifas-latam":
    case "el-nay":
      return "#8cc709"
    case "ultra-ganador":
      return "#572364"
    case "gordoloto":
    case "mono-lokura":
      return "#fb9e08"
    case "rifas-pc":
      return "#3e984b"
    case "not-licencia-process":
      return "#1b39e7"
    case "rifa-los-primos":
      return "#5be1e5"
    case "goyo2time":
    case "dilan-grau":
      return "#eb3326"
    case "agudojhonny":
      return "#f80303"
    case "suena-en-grande":
      return "#34b6fe"
    case "san-de-tu-suerte":
      return "#e3dd6e"
    case "minas-de-baruta":
      return "#20a2a3"
    case "oscar-alarcon-promo":
      return "#07FE9F"
    case "buenaventura":
      return "#0a662b"
    case "the-show-2001":
      return "#7b4696"
    case "maikel-dominguez":
    case "yoiber-mota":
      return "#EA6F06"
    case "white-lion":
      return "#e5a939"
    case "maikel-jaimez":
      return "#fff"
    case "afortunados":
      return "#db926b"
    case "el-rifazo":
      return "#3367d6"
    case "blessed-disc-bar-zz":
    case "rifas-oriente":
    case "greko-rifando":
    case "danielcontrerasrifas":
    case "grow-dp":
    case "gana-con-bonis":
    case "gn-rifas":
      return "#9fc5e8"
    case "la-guaira-market":
      return "#6db336"
    case "rifa-sport":
    case "vip-rifas":
    case "rifas-yaracuy": 
    case "rifa-loca":
        return "#1cbb35"
    case "motor-luck":
    case "flow-exotico":
    case "zpremio":
      return "#e5a939";
    case "jjmc":
      return "#000"
    case "rifas-trebol":
    case "grita-caracas":
    case "anthony-flow":
    case "el-mono":
    case "la-rifa-del-exito":
      return "#196b3c"
    case "easy-cars":
      return "#e6992a"
    case "a-donde-la-negra":
    case "fsm-rifas":
      return "#32c0cc"
    case "luis-bigrau":
      return "#FFFF00"
    case "rifas-jonaiker":
    case "ruedas-extremas":
    case "rifas-roalis":
    case "rifas-petare":
    case "tony-12-grau":
    case "dj-tito":
    case "gana-con-ibelles":
    case "jayakuza":
    case "el-del-puerto-rifas":
    case "rifas-jh-blessd":
    case "johan-eventos":
      return "#d73533"
    case "antoni-contreras":
    case "juega-con-zapata":
    case "franyer-jar":
      return "#1a389c"
    case "flow-shop":
      return "#fff"
    case "yilson-grau":
      return "#1d2eef"
    case "rifas-lmg":
    case "gana-con-salazar":
      return "#2e2ed2"
    case "rifas-va": 
      return "#d8dc03"
    case "rifas-naguara":
    case "los-primos":
    case "el-viejo":
    case "gerej-16":
    case "gana-con-juancho":
    case "wild-life-rescue":
    case "monino":
    case "galenstar":
    case "full-diesel":
    case "alejandro-el-gochito":
    case "emmanuel-dograu":
    case "lobo-guarenas":
      return "#c72534"
    case "rifas-los-chamos":
    case "el-barines":
      return "#fd6f49"
    case "bendecidos-con-villa":
      return "#0185d6"
    case "lavueltaesdios":
      return "#66161f"
    case "ganamos-con-antoni":
    case "w-robles":
      return "#327add"
    case "rifas-deluxe":
    case "rifas-el-charro":
    case "angel-hernandez":
    case "alex-vargas":
    case "rifas-jf":
    case "sobre-ruedas-ok":
    case "punto-alto-ikigai":
    case "b-mendoza":
    case "rifas-chente":
      return "#b98932"
    case "gana-con-laurys":
      return "#72ac3b"
    case "los-ninos":
    case "jgr1":
    case "lotofer":
      return "#1D4293"
    default: 
      return "#aeb2b7"
  }
}

export const getThemeByAccountId = (accountId: string): "dark" | "light" => {
  switch (accountId) {
    case "oscar-alarcon":
    case "kevin-munoz":
    case "gana-con-leonardo":
    case "jj-platinum":
    case "una-vision":
    case "galenstar":
    case "buenaventura":
    case "ale-jef":
    case "yourrmann":
    case "gana-con-salazar":
    case "oscar-alarcon-promo":
    case "danielcontrerasrifas":
    case "vip-rifas":
    case "maikel-dominguez":
    case "blessed-disc-bar-zz":
    case "rifa-sport":
    case "rifas-chente":
    case "ganamos-con-antoni":
    case "maikel-jaimez":
    case "goyo2time":
    case "rifas-trebol":
    case "gn-rifas":
    case "wild-life-rescue":
    case "rifas-naguara":
      return "dark"
    case "jjmc":
    case "white-lion":
    case "agudojhonny":
    case "suena-en-grande":
    case "alex-vargas":
    case "bendecidos-con-villa":
    case "greko-rifando":
    case "rifas-roalis":
    case "jgr1":
      return "light"
    default: 
      return "dark"
  }
}

export const buttonAddStyle = {
    mt: 2,
    marginLeft: 1,
    padding: 0,
    border: 0,
    textDecoration: "underline",
  };